// TODO: Evaluate whether we want to keep using zod
import { z } from 'zod';

export const FormSchema = z.object({
  FirstName: z
    .string()
    .min(1, 'First name is required.')
    .max(400, 'First name cannot exceed 400 characters.'),
  LastName: z
    .string()
    .min(1, 'Last name is required.')
    .max(400, 'First name cannot exceed 400 characters.'),
  Email: z
    .string()
    .email('Email must be a valid email address.')
    // .NET doesn't support "+" in email addresses atm so reject it
    .regex(/^(?!.*\+).*$/, 'Email must not contain "+" character.')
    .max(400, 'Email cannot exceed 400 characters.'),
});

export type FormSchema = z.infer<typeof FormSchema>;
